/// <reference types="node" />
export const CLIENT_VERSION = "5.0.0";